module.exports = __webpack_public_path__ + "img/pk-sales.d1ea3456.png";